import { render, staticRenderFns } from "./PageMain.vue?vue&type=template&id=6da2a612&scoped=true"
import script from "./PageMain.vue?vue&type=script&lang=js"
export * from "./PageMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da2a612",
  null
  
)

export default component.exports